import { teamMoodsViews } from './../team-mood.component';
import { Component, ElementRef, OnInit, Output, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SynchronizationService } from '../../../../services/synchronization.service';
import { SettingsService } from '../../../../services/settings.service';
import 'chartjs-plugin-dragdata';
import { Person } from '../../../../models/person';
import { Vote } from '../../../../models/vote';
import { MoodQuestion } from '../../../../models/moodQuestion';
import { Rating } from '../../../../models/rating';
import { RatingService } from '../../../../services/rating.service';
import { CommunicationService } from '../../../../services/communication.service';

@Component({
  selector: 'app-team-mood-data-collection',
  templateUrl: './team-mood-data-collection.component.html',
  styleUrls: ['./team-mood-data-collection.component.scss']
  })
export class TeamMoodDataCollectionComponent implements OnInit, OnDestroy {
  @ViewChild('divcontainer', { static: true }) private element: ElementRef;
  @Output() navigate = new EventEmitter<teamMoodsViews>();
  public name = 'teamMoodDataCollectionComponent';
  private sprintID: number;
  languages: string[];
  public placeholderComment: string;
  private event: Subscription[] = [];
  public view: teamMoodsViews = teamMoodsViews.voting;
  private moodQuestions: MoodQuestion[] = [];
  public vote: Vote;
  public static readonly componentId = 'TeamMoodDataCollectionComponent';

  constructor(private translate: TranslateService,
    private communicationService: CommunicationService,
    private syncService: SynchronizationService,
    private settingsService: SettingsService,
    private ratingService: RatingService) {
    this.languages = this.translate.getLangs();
  }

  ngOnInit() {
    const projectKey = this.settingsService.getProjectName();
    this.sprintID = this.settingsService.getSprintId(projectKey);
    this.vote = new Vote(null, this.sprintID.toString(), []);
    this.ratingService.getAllQuestions(projectKey).subscribe(res => {
      this.moodQuestions = res;
      this.enrichVote();
    });

    this.communicationService.registerComponent(TeamMoodDataCollectionComponent.componentId, this);
    this.event.push(this.translate.stream('widgets.teamMood.commentForVote').subscribe(res => {
      this.placeholderComment = res;
    }));
  }

  ngOnDestroy(): void {
    this.communicationService.unregisterComponent(TeamMoodDataCollectionComponent.componentId);
  }


  onCommunicationEvent(data: Person): void {
    if (data) {
      this.vote.person = data;
    }
  }

  removePerson(): void {
    this.vote.person = null;
  }

  onClick(event: any, rating: Rating) {
    if (rating !== null) {
      this.vote.ratings.find(x => x.question === rating.question).rating = event['newValue'];
    }
  }

  /**
   * Submit a new generated vote and remove rating which aren't set
   * Not set ratings have the value 0
   */
  submitVote() {
    this.vote.ratings = this.vote.ratings.filter((rating) => (rating.rating > 0));

    this.ratingService.saveVote(this.settingsService.getProjectName(), this.vote).subscribe(res => {
      this.ratingService.sendNewVote();
      this.syncService.sendPersistenceEvent('newTeamMoodVote', this.vote);
      this.navigateToAvg();
    });
  }

  cancelVote() {
    this.navigateToAvg();
  }

  // ID will be set by db
  enrichVote() {
    for (const q of this.moodQuestions) {
      if (q.active) {
        this.vote.ratings.push(new Rating(null, 0, q));
      }
    }
  }

  navigateToAvg() {
    this.navigate.emit(teamMoodsViews.showAvg);
  }
}
